import { School } from "../../../types/school-types";

export const greatSchoolsMock: School[] = [
  {
    "universal-id": "4501819",
    "nces-id": "450117001472",
    "state-id": "0801048",
    name: "Daniel Island School",
    "school-summary":
      "Daniel Island School, a public school located in Charleston, SC, serves grades PK-8 in the Berkeley 01.It has received a GreatSchools Rating of 8 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e,m",
    level: "PK,KG,1,2,3,4,5,6,7,8",
    street: "2365 Daniel Island Drive",
    city: "Charleston",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 471-2301",
    fax: null,
    county: "Berkeley County",
    lat: 32.849197,
    lon: -79.91037,
    "district-name": "Berkeley 01",
    "district-id": 27,
    "web-site": "http://www.bcsdschools.net/DIS",
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/1819-Daniel-Island-School/",
    rating: "8",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 1.4857397442429818,
  },
  {
    "universal-id": "4501323",
    "nces-id": "A9703166",
    "state-id": null,
    name: "Palmetto Christian Academy",
    "school-summary":
      "Palmetto Christian Academy, a private school located in Mount Pleasant, SC, serves grades PK-12 in the .",
    type: "private",
    "level-codes": "p,e,m,h",
    level: "PK,TK,KG,1,2,3,4,5,6,7,8,9,10,11,12",
    street: "361 Egypt Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 881-9967",
    fax: null,
    county: "Charleston County",
    lat: 32.848778,
    lon: -79.856514,
    "district-name": null,
    "district-id": 0,
    "web-site": "http://www.palmettochristianacademy.org/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1323-Palmetto-Christian-Academy/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 1.6520328830452236,
  },
  {
    "universal-id": "4500277",
    "nces-id": "450144001438",
    "state-id": "1001096",
    name: "Belle Hall Elementary School",
    "school-summary":
      "Belle Hall Elementary School, a public school located in Mount Pleasant, SC, serves grades PK-5 in the Charleston 01 School District.It has received a GreatSchools Rating of 9 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e",
    level: "PK,KG,1,2,3,4,5",
    street: "385 Egypt Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 849-2841",
    fax: "(843) 849-2893",
    county: "Charleston County",
    lat: 32.847263,
    lon: -79.855782,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/277-Belle-Hall-Elementary-School/",
    rating: "9",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 1.7067960778952862,
  },
  {
    "universal-id": "4502894",
    "nces-id": null,
    "state-id": null,
    name: "Daniel Island Academy",
    "school-summary":
      "Daniel Island Academy, a private school located in Charleston, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,KG",
    street: "300 Seven Farms Drive",
    city: "Charleston",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 971-5961",
    fax: null,
    county: "Berkeley",
    lat: 32.857815,
    lon: -79.916504,
    "district-name": null,
    "district-id": 0,
    "web-site": "www.danielislandacademy.com ",
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/2894-Daniel-Island-Academy/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 1.8971604508680575,
  },
  {
    "universal-id": "4501121",
    "nces-id": "01263014",
    "state-id": null,
    name: "Bishop England High School",
    "school-summary":
      "Bishop England High School, a private school located in Charleston, SC, serves grades 9-12 in the .",
    type: "private",
    "level-codes": "h",
    level: "9,10,11,12",
    street: "363 Seven Farms Dr",
    city: "Charleston",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 849-9599",
    fax: null,
    county: "Berkeley",
    lat: 32.855865,
    lon: -79.918442,
    "district-name": null,
    "district-id": 0,
    "web-site": "http://www.behs.com/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/1121-Bishop-England-High-School/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 1.9787389240309692,
  },
  {
    "universal-id": "4501131",
    "nces-id": "01263331",
    "state-id": null,
    name: "Trident Academy",
    "school-summary":
      "Trident Academy, a private school located in Mount Pleasant, SC, serves grades 6-10 in the .",
    type: "private",
    "level-codes": "m,h",
    level: "6,7,8,9,10",
    street: "1455 Wakendaw Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-7046",
    fax: null,
    county: "Charleston County",
    lat: 32.829098,
    lon: -79.85405,
    "district-name": null,
    "district-id": 0,
    "web-site": "http://www.tridentacademy.com/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1131-Trident-Academy/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 2.34026041731393,
  },
  {
    "universal-id": "4502893",
    "nces-id": "A0308040",
    "state-id": null,
    name: "O'quinn Schools Of Porter-Gaud - Mount Pleasant",
    "school-summary":
      "O'quinn Schools Of Porter-Gaud - Mount Pleasant, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,TK,KG",
    street: "761 South Shelmore Boulevard",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 881-8506",
    fax: null,
    county: "Charleston County",
    lat: 32.810665,
    lon: -79.879425,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/2893-Oquinn-Schools-Of-Porter-Gaud---Mount-Pleasant/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 2.8007947357301752,
  },
  {
    "universal-id": "4502890",
    "nces-id": null,
    "state-id": null,
    name: "James B Edwards Kaliedescope D",
    "school-summary":
      "James B Edwards Kaliedescope D, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,KG",
    street: "855 Von Kolnitz Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 856-2375",
    fax: null,
    county: "Charleston",
    lat: 32.820026,
    lon: -79.853371,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/2890-James-B-Edwards-Kaliedescope-D/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 2.8115484608597314,
  },
  {
    "universal-id": "4504364",
    "nces-id": "450144001746",
    "state-id": "1001121",
    name: "Lucy Garrett Beckham High",
    "school-summary":
      "Lucy Garrett Beckham High, a public school located in Mount Pleasant, SC, serves grades 9-12 in the .",
    type: "public",
    "level-codes": "h",
    level: "9,10,11,12",
    street: "1560 Mathis Ferry Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 856-6790",
    fax: null,
    county: "Charleston County",
    lat: 32.826889,
    lon: -79.844795,
    "district-name": null,
    "district-id": 0,
    "web-site": "https://www.ccsdschools.com/lucybeckham",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/4364-Lucy-Garrett-Beckham-High/",
    rating: null,
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 2.858568108665664,
  },
  {
    "universal-id": "4500270",
    "nces-id": "450144001329",
    "state-id": "1001093",
    name: "James B. Edwards Elementary School",
    "school-summary":
      "James B. Edwards Elementary School, a public school located in Mount Pleasant, SC, serves grades PK-5 in the Charleston 01 School District.It has received a GreatSchools Rating of 6 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e",
    level: "PK,KG,1,2,3,4,5",
    street: "885 Von Kolnitz Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 849-2805",
    fax: "(843) 849-2892",
    county: "Charleston County",
    lat: 32.818489,
    lon: -79.853745,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "http://jbedwards.ccsdschools.com/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/270-James-B.-Edwards-Elementary-School/",
    rating: "6",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 2.879401493780059,
  },
  {
    "universal-id": "4502683",
    "nces-id": "A1303208",
    "state-id": null,
    name: "Sundrops Montessori School",
    "school-summary":
      "Sundrops Montessori School, a private school located in Mount Pleasant, SC, serves grades PK-9 in the .",
    type: "private",
    "level-codes": "p,e,m",
    level: "PK,TK,KG,1,2,3,4,5,6,7,8,9",
    street: "955 Houston Northcutt Boulevard",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 849-3652",
    fax: null,
    county: "Charleston County",
    lat: 32.80077,
    lon: -79.88942,
    "district-name": null,
    "district-id": 0,
    "web-site": "www.sundropsmontessori.com",
    "overview-url":
      "https://www.greatschools.org/south-carolina/isle-of-palms/2683-Sundrops-Montessori-School/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 3.476759914002013,
  },
  {
    "universal-id": "4501103",
    "nces-id": "01262724",
    "state-id": null,
    name: "Christ Our King-Stella Maris School",
    "school-summary":
      "Christ Our King-Stella Maris School, a private school located in Mount Pleasant, SC, serves grades PK-8 in the .",
    type: "private",
    "level-codes": "p,e,m",
    level: "PK,TK,KG,1,2,3,4,5,6,7,8",
    street: "1183 Russell Drive",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-4721",
    fax: "(843) 971-7850",
    county: "Charleston County",
    lat: 32.796955,
    lon: -79.86293,
    "district-name": null,
    "district-id": 0,
    "web-site": "http://www.coksm.org/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1103-Christ-Our-King-Stella-Maris-School/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 3.9415447326233113,
  },
  {
    "universal-id": "4504330",
    "nces-id": "A1390322",
    "state-id": null,
    name: "University School of the Lowcountry",
    "school-summary":
      "University School of the Lowcountry, a private school located in Mount Pleasant, SC, serves grades 3-12 in the .",
    type: "private",
    "level-codes": "e,m,h",
    level: "3,4,5,6,7,8,9,10,11,12",
    street: "690 Coleman Boulevard",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-0902",
    fax: null,
    county: "Charleston County",
    lat: 32.79269,
    lon: -79.871094,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/4330-University-School-Of-The-Lowcountry/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.103510134589335,
  },
  {
    "universal-id": "4500243",
    "nces-id": "450144000236",
    "state-id": "1001090",
    name: "Mamie Whitesides Elementary School",
    "school-summary":
      "Mamie Whitesides Elementary School, a public school located in Mount Pleasant, SC, serves grades PK-5 in the Charleston 01 School District.It has received a GreatSchools Rating of 8 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e",
    level: "PK,KG,1,2,3,4,5",
    street: "1565 Rifle Range Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 849-2838",
    fax: "(843) 849-2884",
    county: "Charleston County",
    lat: 32.809391,
    lon: -79.834091,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site":
      "http://www.ccsdschools.com/schoolpages/whitesidesel/indexpi.htm",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/243-Mamie-Whitesides-Elementary-School/",
    rating: "8",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.1146163023351185,
  },
  {
    "universal-id": "4501510",
    "nces-id": "450144000856",
    "state-id": "1001614",
    name: "East Cooper Montessori Charter School",
    "school-summary":
      "East Cooper Montessori Charter School, a charter school located in Mount Pleasant, SC, serves grades PK-8 in the Charleston 01 School District.It has received a GreatSchools Rating of 8 out of 10, based on a variety of school quality measures.",
    type: "charter",
    "level-codes": "p,e,m",
    level: "PK,KG,1,2,3,4,5,6,7,8",
    street: "1120 Rifle Range Road",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 216-2883",
    fax: "(843) 216-8880",
    county: "Charleston County",
    lat: 32.79747,
    lon: -79.853157,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "http://www.montessoricharterschool.com",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1510-East-Cooper-Montessori-Charter-School/",
    rating: "8",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.127770576758174,
  },
  {
    "universal-id": "4501856",
    "nces-id": null,
    "state-id": null,
    name: "University School of the Lowcountry",
    "school-summary":
      "University School of the Lowcountry, a private school located in Mount Pleasant, SC, serves grades 3-12 in the .",
    type: "private",
    "level-codes": "e,m,h",
    level: "3,4,5,6,7,8,9,10,11,12",
    street: "690 Coleman Blvd.",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-0902",
    fax: "(843) 884-0905",
    county: "Charleston",
    lat: 32.792374,
    lon: -79.870583,
    "district-name": null,
    "district-id": 0,
    "web-site": "www.uslowcountry.org",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1856-University-School-Of-The-Lowcountry/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.130779449960854,
  },
  {
    "universal-id": "4501635",
    "nces-id": "K9305721",
    "state-id": null,
    name: "Montessori Of Mt Pleasant",
    "school-summary":
      "Montessori Of Mt Pleasant, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,TK,KG",
    street: "208 Church Street",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-1117",
    fax: null,
    county: "Charleston County",
    lat: 32.790527,
    lon: -79.879601,
    "district-name": null,
    "district-id": 0,
    "web-site": "http://mmpschool.com/",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1635-Montessori-Of-Mt-Pleasant/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.185526986217953,
  },
  {
    "universal-id": "4502879",
    "nces-id": null,
    "state-id": null,
    name: "Little Learner's Lodge",
    "school-summary":
      "Little Learner's Lodge, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,KG",
    street: "208 Church Street",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-4471",
    fax: null,
    county: "Charleston",
    lat: 32.790466,
    lon: -79.879562,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/2879-Little-Learners-Lodge/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.189897411361179,
  },
  {
    "universal-id": "4500265",
    "nces-id": "450144001218",
    "state-id": "1001065",
    name: "Moultrie Middle School",
    "school-summary":
      "Moultrie Middle School, a public school located in Mount Pleasant, SC, serves grades 6-8 in the Charleston 01 School District.It has received a GreatSchools Rating of 8 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "m",
    level: "6,7,8",
    street: "645 Coleman Boulevard",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 849-2819",
    fax: "(843) 849-2899",
    county: "Charleston County",
    lat: 32.790504,
    lon: -79.8722,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "http://www.ccsdschools.com/schoolpages/moultrie/indexhmt.html",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/265-Moultrie-Middle-School/",
    rating: "8",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.240158077224204,
  },
  {
    "universal-id": "4501719",
    "nces-id": "A0302893",
    "state-id": null,
    name: "Mt Pleasant Presbyterian Church Learning Center",
    "school-summary":
      "Mt Pleasant Presbyterian Church Learning Center, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,TK,KG",
    street: "302 Hibben Street",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 856-2020",
    fax: null,
    county: "Charleston County",
    lat: 32.78957,
    lon: -79.878555,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1719-Mt-Pleasant-Presbyterian-Church-Learning-Center/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.256268408167323,
  },
  {
    "universal-id": "4502888",
    "nces-id": "K9305723",
    "state-id": null,
    name: "St Andrews Day School",
    "school-summary":
      "St Andrews Day School, a private school located in Mount Pleasant, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,TK,KG",
    street: "440 Whilden Street",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 284-4356",
    fax: null,
    county: "Charleston County",
    lat: 32.788486,
    lon: -79.875443,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/2888-St-Andrews-Day-School/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.349891508320181,
  },
  {
    "universal-id": "4504218",
    "nces-id": "450117001671",
    "state-id": "0801054",
    name: "Philip Simmons Elementary",
    "school-summary":
      "Philip Simmons Elementary, a public school located in Wando, SC, serves grades PK-4 in the Berkeley 01.It has received a GreatSchools Rating of 5 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e",
    level: "PK,KG,1,2,3,4",
    street: "2095 Seven Sticks Drive",
    city: "Wando",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 471-2580",
    fax: null,
    county: "Berkeley County",
    lat: 32.912804,
    lon: -79.861183,
    "district-name": "Berkeley 01",
    "district-id": 27,
    "web-site": "http://www.bcsdschools.net/Domain/4852",
    "overview-url":
      "https://www.greatschools.org/south-carolina/wando/4218-Philip-Simmons-Elementary/",
    rating: "5",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.48951458361813,
  },
  {
    "universal-id": "4504227",
    "nces-id": "450117001670",
    "state-id": "0801055",
    name: "Philip Simmons Middle",
    "school-summary":
      "Philip Simmons Middle, a public school located in Wando, SC, serves grades 5-8 in the Berkeley 01.It has received a GreatSchools Rating of 4 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "e,m",
    level: "5,6,7,8",
    street: "2065 Seven Sticks Drive",
    city: "Wando",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 471-2590",
    fax: null,
    county: "Berkeley County",
    lat: 32.912937,
    lon: -79.860466,
    "district-name": "Berkeley 01",
    "district-id": 27,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/4227-Philip-Simmons-Middle/",
    rating: "4",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.511141648129047,
  },
  {
    "universal-id": "4501128",
    "nces-id": "01263251",
    "state-id": null,
    name: "Coastal Christian Preparatory School",
    "school-summary":
      "Coastal Christian Preparatory School, a private school located in Mount Pleasant, SC, serves grades PK-12 in the .",
    type: "private",
    "level-codes": "p,e,m,h",
    level: "PK,TK,KG,1,2,3,4,5,6,7,8,9,10,11,12",
    street: "681 McCants Drive",
    city: "Mount Pleasant",
    state: "SC",
    fipscounty: 45019,
    zip: "29464",
    phone: "(843) 884-3663",
    fax: "(843) 884-9608",
    county: "Charleston County",
    lat: 32.786457,
    lon: -79.863373,
    "district-name": null,
    "district-id": 0,
    "web-site": "www.coastalchristian.org",
    "overview-url":
      "https://www.greatschools.org/south-carolina/mount-pleasant/1128-Coastal-Christian-Preparatory-School/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.626951234667628,
  },
  {
    "universal-id": "4500233",
    "nces-id": "450144000226",
    "state-id": "1001076",
    name: "Sanders-Clyde Elementary School",
    "school-summary":
      "Sanders-Clyde Elementary School, a public school located in Charleston, SC, serves grades PK-5 in the Charleston 01 School District.It has received a GreatSchools Rating of 2 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "p,e",
    level: "PK,KG,1,2,3,4,5",
    street: "805 Morrison Drive",
    city: "Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29403",
    phone: "(843) 724-7783",
    fax: "(843) 720-3138",
    county: "Charleston County",
    lat: 32.801155,
    lon: -79.938301,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "http://www.ccsdschools.com/schoolpages/sce/Clyde.html",
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/233-Sanders-Clyde-Elementary-School/",
    rating: "2",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.63272422235202,
  },
  {
    "universal-id": "4504298",
    "nces-id": "A1303170",
    "state-id": null,
    name: "Harvest Time International Academy",
    "school-summary":
      "Harvest Time International Academy, a private school located in Charleston, SC, serves grades 4-12 in the .",
    type: "private",
    "level-codes": "e,m,h",
    level: "4,5,6,7,8,9,10,11,12",
    street: "227 Huger Street",
    city: "Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29403",
    phone: "(843) 647-5911",
    fax: null,
    county: "Charleston County",
    lat: 32.802917,
    lon: -79.942291,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/4298-Harvest-Time-International-Academy/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.704300520710354,
  },
  {
    "universal-id": "4504307",
    "nces-id": "A1703286",
    "state-id": null,
    name: "Meeting Street Academy",
    "school-summary":
      "Meeting Street Academy, a private school located in Charleston, SC, serves grades PK-5 in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,TK,KG,1,2,3,4,5",
    street: "642 Meeting Street",
    city: "Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29403",
    phone: "(843) 735-7102",
    fax: null,
    county: "Charleston County",
    lat: 32.805695,
    lon: -79.946259,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/4307-Meeting-Street-Academy/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.741577292554712,
  },
  {
    "universal-id": "4500271",
    "nces-id": "450144001330",
    "state-id": "1001018",
    name: "Military Magnet Academy",
    "school-summary":
      "Military Magnet Academy, a public school located in North Charleston, SC, serves grades 6-12 in the Charleston 01 School District.It has received a GreatSchools Rating of 6 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "m,h",
    level: "6,7,8,9,10,11,12",
    street: "2950 Carner Avenue",
    city: "North Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29405",
    phone: "(843) 745-7102",
    fax: "(843) 566-7791",
    county: "Charleston County",
    lat: 32.850105,
    lon: -79.968185,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "http://militarymagnet.ccsdschools.com/home.aspx",
    "overview-url":
      "https://www.greatschools.org/south-carolina/north-charleston/271-Military-Magnet-Academy/",
    rating: "6",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.837028844122435,
  },
  {
    "universal-id": "4500208",
    "nces-id": "450144000197",
    "state-id": "1001033",
    name: "Chicora Elementary School",
    "school-summary":
      "Chicora Elementary School, a public school located in North Charleston, SC, serves grades 1-5 in the Charleston 01 School District.It has received a GreatSchools Rating of 4 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "e",
    level: "1,2,3,4,5",
    street: "3100 Carner Avenue",
    city: "North Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29405",
    phone: "(843) 746-2210",
    fax: "(843) 566-7792",
    county: "Charleston County",
    lat: 32.852417,
    lon: -79.970154,
    "district-name": "Charleston 01 School District",
    "district-id": 29,
    "web-site": "www.ccsdschools.com",
    "overview-url":
      "https://www.greatschools.org/south-carolina/north-charleston/208-Chicora-Elementary-School/",
    rating: "4",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.951953906570395,
  },
  {
    "universal-id": "4502655",
    "nces-id": null,
    "state-id": null,
    name: "St Luke Head Start Center",
    "school-summary":
      "St Luke Head Start Center, a private school located in Charleston, SC, serves grades PK-K in the .",
    type: "private",
    "level-codes": "p,e",
    level: "PK,KG",
    street: "Po Box 20369",
    city: "Charleston",
    state: "SC",
    fipscounty: 45019,
    zip: "29413",
    phone: "(843) 889-6347",
    fax: null,
    county: "Charleston",
    lat: 32.790001,
    lon: -79.93,
    "district-name": null,
    "district-id": 0,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/2655-St-Luke-Head-Start-Center/",
    rating: null,
    year: null,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.959891011221992,
  },
  {
    "universal-id": "4504222",
    "nces-id": "450117001681",
    "state-id": "0801056",
    name: "Philip Simmons High",
    "school-summary":
      "Philip Simmons High, a public school located in Charleston, SC, serves grades 9-12 in the Berkeley 01.It has received a GreatSchools Rating of 7 out of 10, based on a variety of school quality measures.",
    type: "public",
    "level-codes": "h",
    level: "9,10,11,12",
    street: "3080 River Village Drive",
    city: "Charleston",
    state: "SC",
    fipscounty: 45015,
    zip: "29492",
    phone: "(843) 471-2960",
    fax: null,
    county: "Berkeley County",
    lat: 32.91708,
    lon: -79.850868,
    "district-name": "Berkeley 01",
    "district-id": 27,
    "web-site": null,
    "overview-url":
      "https://www.greatschools.org/south-carolina/charleston/4222-Philip-Simmons-High/",
    rating: "7",
    year: 2024,
    "rating-description":
      "The GreatSchools Rating helps parents compare schools within a state based on a variety of school quality indicators and provides a helpful picture of how effectively each school serves all of its students. Ratings are on a scale of 1 (below average) to 10 (above average) and can include test scores, college readiness, academic progress, advanced courses, equity, discipline and attendance data. We also advise parents to visit schools, consider other information on school performance and programs, and consider family needs as part of the school selection process.",
    distance: 4.977051772776417,
  },
];
